import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image" }
const _hoisted_2 = { class: "news-content" }
const _hoisted_3 = { class: "meta" }
const _hoisted_4 = { nowrap: "" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image")
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")
  const _component_SourceTag = _resolveComponent("SourceTag")
  const _component_Segment = _resolveComponent("Segment")

  return (_openBlock(), _createBlock(_component_Segment, {
    class: "news-item pointer",
    flat: "",
    onClick: $options.onClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_image, {
          class: "el-image",
          fit: "cover",
          src: $options.image_url
        }, {
          error: _withCtx(() => [
            _createVNode(_component_el_image, {
              class: "placeholder",
              fit: "cover",
              src: "assets/news-placeholder.png"
            })
          ]),
          placeholder: _withCtx(() => [
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "16.3rem",
              "border-radius": "0.8rem"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["src"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        ($props.preview?.title)
          ? (_openBlock(), _createBlock(_component_Ellipsis, {
              key: 0,
              class: "title",
              lines: 2
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.preview.title), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString($options.formatted_date), 1 /* TEXT */),
          ($props.source && !!_ctx.$slots.meta)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                icon: "dot",
                width: "0.7rem",
                height: "0.8rem"
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_SourceTag, {
            class: "source",
            size: "1.8rem",
            logo: $props.source?.icon_url,
            name: $props.source?.name
          }, null, 8 /* PROPS */, ["logo", "name"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClick"]))
}